var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgStaff = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.91458 8.52053C8.92217 9.88872 10.0368 10.9927 11.4042 10.9858C12.7731 10.9783 13.8763 9.86442 13.8695 8.49623C13.8634 7.12729 12.7481 6.02408 11.3799 6.03092C10.0117 6.03699 8.90775 7.15234 8.91458 8.52053Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8977 19.9378C16.8833 16.468 14.4316 13.6678 11.4222 13.6853C8.41292 13.7027 5.98558 16.5302 6.00006 20L16.8977 19.9378Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3975 8.39164C17.4013 9.15674 18.024 9.77383 18.7891 9.76958C19.5537 9.76581 20.1708 9.14307 20.167 8.37796C20.1633 7.61333 19.5401 6.99625 18.7754 7.00002C18.0108 7.00426 17.3932 7.627 17.3975 8.39164Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8541 15.4873L20.1631 15.4821L21.3973 15.475C21.3924 14.3752 20.9931 13.3834 20.3546 12.6776C20.2167 12.5259 20.0682 12.3868 19.9095 12.2628C19.7569 12.1435 19.5953 12.0384 19.426 11.9488C19.1899 11.8234 18.9392 11.7282 18.6774 11.6679C18.4569 11.6174 18.2286 11.5915 17.9946 11.5929",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99998 8.39164C5.99621 9.15674 5.37347 9.77383 4.60836 9.76958C3.84372 9.76581 3.22664 9.14307 3.23041 8.37796C3.23418 7.61333 3.85739 6.99625 4.62203 7.00002C5.38667 7.00426 6.00422 7.627 5.99998 8.39164Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54337 15.4873L3.23433 15.4821L2.00015 15.475C2.00506 14.3752 2.40432 13.3834 3.04288 12.6776C3.18074 12.5259 3.32924 12.3868 3.48796 12.2628C3.64054 12.1435 3.80213 12.0384 3.97148 11.9488C4.20752 11.8234 4.45828 11.7282 4.72009 11.6679C4.94058 11.6174 5.16884 11.5915 5.40283 11.5929",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStaff, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Staff.af0f3fcc.svg";
export { ForwardRef as ReactComponent };